(function ($) {
  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for desktop
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(min-width: 768px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for mobile
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(max-width: 767px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Common JS - All Pages
  ////////////////////////////////////////////////////////////////////////////////////
  var Sage = {
    common: {
      init: function () {

        ////////////////////////////////////////////////////////////////////////////////////
        // AOS - Animate on scroll init
        ////////////////////////////////////////////////////////////////////////////////////
        AOS.init({
          delay: 100, // values from 0 to 3000, with step 50ms
          initClassName: 'aos-init', // class applied after initialization
          animatedClassName: 'aos-animate', // class applied on animation
          duration: 400, // values from 0 to 3000, with step 50ms
          easing: 'ease', // default easing for AOS animations
          once: true, // whether animation should happen only once - while scrolling down
          anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Search Functionality
        ////////////////////////////////////////////////////////////////////////////////////
        $(document).on('click', '.js-init-sitewide-search', function () {

          ////////////////////////////////////////////////////////////////////////////////////
          // Show Search
          ////////////////////////////////////////////////////////////////////////////////////
          if ($('.js-section-site-search').is(':hidden')) {
            $('.js-section-site-search').slideDown('slow', function () {
              $('#header-search').val('').focus();
            });
          } else {
            $('.js-section-site-search').slideUp('slow');
          }

          ////////////////////////////////////////////////////////////////////////////////////
          // Return False
          ////////////////////////////////////////////////////////////////////////////////////
          return false;

        });

        //////////////////////////////////////////////////////////////
        // Animate Hamburger
        //////////////////////////////////////////////////////////////
        $('.navbar-toggler').on('click', function () {
          $(this).toggleClass('active');
          $('.navbar').toggleClass('active');
          $('body').toggleClass('navbar-active');
        });

        //////////////////////////////////////////////////////////////
        // Calculate True VH
        //////////////////////////////////////////////////////////////
        // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        // We listen to the resize event
        window.addEventListener('resize', () => {
          // We execute the same script as before
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Contact Form Validation
        ////////////////////////////////////////////////////////////////////////////////////
        if ($('#js-form-contact').length) {
        $('#js-form-contact').validate({
          rules: {
            email: {
              remote: {
                url: '/wp-admin/admin-ajax.php',
                type: "POST",
                data: {
                  'action': 'valid_email_lookup',
                  'email_value': function () {
                    return $("#email").val();
                  },
                },
              },
            },
            phone_number: {
              validPhone: true,
            },
            'checkbox_multiple': {
              required: true,
            },
            'radio_multiple': {
              required: true,
            }
          },
          highlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-invalid').removeClass('is-valid');
            $(element).parents().children('.invalid-feedback').css('display', 'block');
            $(element).parents().children('.valid-feedback').css('display', 'none');
          },
          unhighlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-valid').removeClass('is-invalid');
            $(element).parents().children('.invalid-feedback').css('display', 'none');
            $(element).parents().children('.valid-feedback').css('display', 'block');
          },
          errorPlacement: function () {
            $(this).parents('form').addClass('was-validated');
            return false;
          },
          submitHandler: function (form) {

            ////////////////////////////////////////////////////////////////////////////////////
            // Display ajax loader
            ////////////////////////////////////////////////////////////////////////////////////
            $('.js-contact-error, .js-contact-recaptcha-error, #js-form-contact').css('display', 'none');
            $('.js-contact-loader').css('display', 'block');

            ////////////////////////////////////////////////////////////////////////////////////
            // Validate reCaptcha
            ////////////////////////////////////////////////////////////////////////////////////
            generate_google_recaptcha_token('contact_form').then(function (response) {

              ////////////////////////////////////////////////////////////////////////////////////
              // reCaptcha Response
              ////////////////////////////////////////////////////////////////////////////////////
              var reCaptchaResponse = jQuery.parseJSON(response);

              ////////////////////////////////////////////////////////////////////////////////////
              // IF Invalid - Show Error
              ////////////////////////////////////////////////////////////////////////////////////
              if (reCaptchaResponse.valid == 'false') {

                ////////////////////////////////////////////////////////////////////////////////////
                // Display Error
                ////////////////////////////////////////////////////////////////////////////////////
                $('.js-contact-loader').css('display', 'none');
                $('#js-form-contact, .js-contact-recaptcha-error').css('display', 'block');

                ////////////////////////////////////////////////////////////////////////////////////
                // ELSE Success
                ////////////////////////////////////////////////////////////////////////////////////
              } else {

                ////////////////////////////////////////////////////////////////////////////////////
                // Ajax Variables
                ////////////////////////////////////////////////////////////////////////////////////
                var apiRequestError = false; // API Request Error Status

                ////////////////////////////////////////////////////////////////////////////////////
                // Mandrill Payload
                ////////////////////////////////////////////////////////////////////////////////////
                var mandrillPayload = mandrill_json_payload('#js-form-contact'); // Mandrill API Payload

                console.log(mandrillPayload);
                // TEMPLATE: Remove this return to enable Mandrill form submission
                return false;

                ////////////////////////////////////////////////////////////////////////////////////
                // TEMPLATE: Campaign Monitor Subscriber Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var cmPayload = new Object();
                // cmPayload.customFields = {}
                // cmPayload.listID = 'a480aacea0c318f253bf9feff5d97c83';
                // cmPayload.name = $('#first_name').val() + ' ' + $('#last_name').val();
                // cmPayload.emailAddress = $('#email').val();

                // cmPayload.customFields.PhoneNumber = $('#phone_number').val();
                // cmPayload.customFields.Message = $('#message').val();
                // cmPayload.customFields.RadioOptions = $('input[name=radioexample]:checked').val();
                // cmPayload.customFields.SelectOption = $('#select_example').val();

                // cmPayload.customFields.CheckboxField = [];
                // $('[name="checkboxexample"]').each(function( index ) {
                //   if($(this).is(':checked')) {
                //     cmPayload.customFields.CheckboxField.push($(this).val());
                //   }
                // });

                ////////////////////////////////////////////////////////////////////////////////////
                // TEMPLATE: MailChimp Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var mailChimpPayload = new Object();
                // mailChimpPayload.customFields = {}
                // mailChimpPayload.listID = 'f0dddbd24e';
                // mailChimpPayload.emailAddress = $('#email').val();

                // ////////////////////////////////////////////////////////////////////////////////////
                // // MailChimp custom fields
                // ////////////////////////////////////////////////////////////////////////////////////
                // mailChimpPayload.customFields.FNAME = $('#first_name').val();
                // mailChimpPayload.customFields.LNAME = $('#last_name').val();
                // mailChimpPayload.customFields.MERGE3 = $('#phone_number').val();

                ////////////////////////////////////////////////////////////////////////////////////
                // Load call to API
                ////////////////////////////////////////////////////////////////////////////////////
                $.when(

                  //////////////////////////////////////////////////////////////////////////////////
                  // Mandrill Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  $.ajax({
                    type: "POST",
                    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mandrill/notification',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: mandrillPayload,
                    success: function (data) {

                      ////////////////////////////////////////////////////////////////////////////////////
                      // If there is an error with the Mandrill Call, display in console.
                      ////////////////////////////////////////////////////////////////////////////////////
                      if (data.status == 'error') {

                        ////////////////////////////////////////////////////////////////////////////////////
                        // Log Error
                        ////////////////////////////////////////////////////////////////////////////////////
                        console.log(data);
                        apiRequestError = true;

                      }

                    },
                  })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Campaign Monitor Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/cm/subscriber/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(cmPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // MailChimp Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mailchimp/member/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(mailChimpPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Once all api calls are complete
                  //////////////////////////////////////////////////////////////////////////////////
                ).then(function () {

                  ////////////////////////////////////////////////////////////////////////////////////
                  // Display Success / Error based on returned API
                  ////////////////////////////////////////////////////////////////////////////////////
                  if (apiRequestError == false) {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Success Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('.js-contact-success').css('display', 'block');

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Data Layer
                    ////////////////////////////////////////////////////////////////////////////////////
                    dataLayer.push({
                      'event': 'gaTriggerEvent',
                      'gaEventCategory': 'Form',
                      'gaEventAction': 'Enquiry',
                      'gaEventLabel': 'Success'
                    });

                  } else {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Error Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('#js-form-contact').css('display', 'block');
                    $('.js-contact-error').css('display', 'block');

                  }


                });


              }
            });

          } // END ELSE VALID RECAPTCHA
        }); // END GENERATE GOOGLE reCAptcha Token
        } // if #js-form-contact exists

        ////////////////////////////////////////////////////////////////////////////////////
        // Chosen Init
        ////////////////////////////////////////////////////////////////////////////////////
        $('body').find('select').each(function() {
          $(this).chosen();
        });
      }
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // Home page
    ////////////////////////////////////////////////////////////////////////////////////
    home: {
      init: function () {}
    },
  };

  ////////////////////////////////////////////////////////////////////////////////////
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  ////////////////////////////////////////////////////////////////////////////////////
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


jQuery(document).ready(function ($) {

  ////////////////////////////////////////////////////////////////
  // Chosen Dropdown
  ////////////////////////////////////////////////////////////////
  $(document).on('click', '.chosen-results li', function () {
    const $chosen = $(this).closest('.chosen-container');
    const $select = $chosen.prev('select');

    setTimeout(() => {
      $chosen.toggleClass('is-filled', $select.val() !== '');
    }, 0);
  });
  
});